import {
  Button,
  Card,
  CardActions,
  CardContent,
  FormControl,
  FormGroup,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Snackbar,
  SnackbarContent,
  TextField,
  Tooltip,
} from "@material-ui/core";
import "./InformacoesSellout.scss";
import InfoOutlined from "@material-ui/icons/Info";
import * as React from "react";
import { Footer, Header, Navigation } from "../../shared";
import { AdministrationMenu } from "../shared/menu/AdministrationMenu";
import { useEffect, useState } from "react";
import { getError } from "../../../services/ErrorService";
import Rest from "src/services/Rest";
import TableInformacoesSellout, { ITipoOrder } from "./TableInformacoesSellout";
import { CurrentDate, SomeDaysAgo } from "src/services";
import InformacoesSelloutModal from "./InformacoesSelloutModal";
import ExportInProgress from "src/component/export-in-progress/ExportInProgress";
import GetAppIcon from "@material-ui/icons/GetApp";

const styles = {
  textField: {
    marginLeft: 5,
    marginRight: 5,
  },
};

const integrados = [
  {"name": "Todos", "tipo": ""},
  {"name": "Integrados", "tipo": "true"},
  {"name": "Não integrados", "tipo": "false"},
];

const finalDate = CurrentDate();
const initDate = SomeDaysAgo(32);

function InformacoesSellout() {
  const [loading, setStateLoading] = useState<boolean>(false);
  const [processando, setProcessando] = useState<boolean>(false);
  const [listSku, setStateListSku] = useState([]);
  const [filters, setStateFilters] = useState({
    endDate: finalDate,
    initialDate: initDate,
    integrados: "",
    loja: "",
    page: 0,
    size: 10,
    sortStatement: {
      campo: "dia_venda",
      direction: "desc",
    } as ITipoOrder,
    term: "",
    total: 0,
  });

  const [alert, setStateAlert] = useState({
    message: "",
    open: false,
    type: "",
  });

  const handleFilter = (ev: any, chave: string) => {
    const params = Object.assign({}, filters);
    params[chave] = ev.target.value;
    setStateFilters(params);
  };

  const openAlert = (msg: string, tipo: string) => {
    const item = { message: msg, type: tipo, open: true };
    setStateAlert(item);
  };

  const closeAlert = () => {
    const item = { message: "", type: "", open: false };
    setStateAlert(item);
  };

  const columns = [
    {
      render: (item: any) => <span>{item.sku}</span>,
      title: "SKU",
    },

    {
      render: (item: any) => <span>{item.isbn}</span>,
      title: "ISBN",
    },
    
    {
      render: (item: any) => (
        <div style={{ width: "300px" }}>
          {" "}
          <span>{item.descricao}</span>
        </div>
      ),
      title: "Produto",
    },
    {
      render: (item: any) => <span>{item.cnpj}</span>,
      title: "CNPJ",
    },
    {
      render: (item: any) => (
        <div style={{ width: "200px" }}>
          <span>{item.nome_loja}</span>
        </div>
      ),
      title: "Loja",
    },
    {
      render: (item: any) => <span>{item.quantidade}</span>,
      title: "Quantidade",
    },
    {
      render: (item: any) => (
        <div style={{ width: "100px" }}>
          <span>
            {item.unit_value ? `R$ ${item.unit_value}` : item.unit_value}
          </span>
        </div>
      ),
      title: "Valor Unitário",
    },
    {
      render: (item: any) => (
        <div style={{ width: "100px" }}>
          <span>{item.desconto ? `R$ ${item.desconto}` : item.desconto}</span>
        </div>
      ),
      title: "Desconto",
    },
    {
      render: (item: any) => (
        <div style={{ width: "100px" }}>
          <span>
            {item.valor_adicional
              ? `R$ ${item.valor_adicional}`
              : item.valor_adicional}
          </span>
        </div>
      ),
      title: "Valor Adicional",
    },
    {
      render: (item: any) => <span>{item.venda_cancelada}</span>,
      title: "Venda Cancelada",
    },
    {
      render: (item: any) => <span>{item.cfop}</span>,
      title: "CFOP",
    },
    {
      campo: "dia_venda",
      render: (item: any) => <span>{item.dia_venda}</span>,
      sortStatement: true,
      title: "Data Venda",
    },
    {
      campo: "data_criacao",
      render: (item: any) => <span>{item.data_criacao}</span>,
      sortStatement: true,
      title: "Data Criação",
    },
    {
      render: (item: any) => <span>{item.data_alteracao}</span>,
      title: "Data Alteração",
    },
    {
      render: (item: any) => <InformacoesSelloutModal item={item} />,
      title: "Detalhes",
    },
  ];

  const textFieldStyle = () => {
    return Object.assign({ width: "350px" }, styles.textField);
  };

  const selectFieldStyle = () => {
    return Object.assign({ width: "200px" }, styles.textField);
  };

  const handleSort = (params: any) => {
    const filtro = Object.assign({}, filters);
    filtro.sortStatement = params;
    setStateFilters(filtro);
    search(filtro);
  };

  const handleChangePage = (ev: any, pageParam: number) => {
    const params = {
      endDate: filters.endDate,
      initialDate: filters.initialDate,
      integrados: filters.integrados,
      loja: filters.loja,
      page: pageParam,
      size: filters.size,
      sortStatement: filters.sortStatement,
      term: filters.term,
      total: filters.total,
    };
    search(params);
  };

  const handleClearFilter = () => {   
    const params = {
      endDate: finalDate,
      grupo: "",
      initialDate: initDate,
      integrados: "",
      loja: "",
      page: 0,
      processando: false,
      size: 10,
      sortStatement: {
        campo: "dia_venda",
        direction: "desc",
      } as ITipoOrder,
      term: "",
      total: 0,
    };
    search(params);
  };

  const requestExport = async () => {
    const endPoint = `informacoes-sellout/export`;
    const response = await Rest.PostBody(endPoint, filters);
    if (response) {
      openAlert('O relatório está sendo preparado para download', 'sucess');
      setProcessando(true);
    }
  };

  const search = async (filtro: any) => {
    setStateLoading(true);
    let endPoint = `informacoes-sellout?page=${filtro.page}&size=${filtro.size}`;

    if (!!filtro.term && filtro.term !== "") {
      endPoint += `&term=${filtro.term}`;
    }

    if (!!filtro.loja && filtro.loja !== "") {
      endPoint += `&loja=${filtro.loja}`;
    }

    if (!!filtro.initialDate && filtro.initialDate !== "") {
      endPoint += `&initialDate=${filtro.initialDate}`;
    }

    if (!!filtro.integrados && filtro.integrados !== "") {
      endPoint += `&integrados=${filtro.integrados}`;
    }

    if (!!filtro.endDate && filtro.endDate !== "") {
      endPoint += `&endDate=${filtro.endDate}`;
    }
    if (!!filtro.sortStatement) {
      if (filtro.sortStatement.direction && filtro.sortStatement.campo) {
        endPoint += `&direction=${filtro.sortStatement.direction}&campo=${filtro.sortStatement.campo}`;
      }
    }
    const itens = filtro;
    await Rest.GET(endPoint, null)
      .then((response) => response.json())
      .then((result: any) => {
        if (result && result.error) {
          const erro = getError(result.error);
          openAlert(erro.message, "erro");
        } else {
          setStateListSku(result.dados);

          itens.total = Number(result.count);
        }
        setStateFilters(itens);
        setStateLoading(false);
      });
  };

  useEffect(() => {
    search(filters);
  }, []);

  return (
    <div>
      <Header
        title={"Informações Sellout"}
        name={"Administrativo"}
        link={"/dashboard"}
      />

      <Navigation
        name={"Informações Sellout"}
        linkDefault={"/administration/informacoesSellout"}
        link={"/dashboard"}
        linkTitle={"Produtos"}
        painel={3}
        icon={<InfoOutlined />}
      />
      <div className="informacoes-sellout-body">
        <AdministrationMenu paramIcon={null} />

        <div className="wrapper">
          <Grid container={true} spacing={16}>
            <Grid item={true} xs={12}>
              <div>
                <Paper className="analytical-panel">
                  <Grid container={true} direction="column" spacing={16}>
                    <Grid item={true} xs={12}>
                      <Card>
                        <CardContent>
                          <Snackbar
                            anchorOrigin={{
                              horizontal: "center",
                              vertical: "center",
                            }}
                            open={alert.open}
                            autoHideDuration={4000}
                            onClose={closeAlert}
                          >
                            <SnackbarContent
                              message={alert.message}
                              style={styles[alert.type]}
                            />
                          </Snackbar>
                          <form>
                            <CardContent>
                              <div className="export">
                                <div className="analytical-date">
                                  <TextField
                                    color="primary"
                                    defaultValue={filters.initialDate}
                                    value={filters.initialDate}
                                    id="initialDate"
                                    label="Data Inicial da Venda"
                                    type="date"
                                    required={true}
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    onChange={(ev) =>
                                      handleFilter(ev, "initialDate")
                                    }
                                    style={textFieldStyle()}
                                  />

                                  <TextField
                                    color="primary"
                                    defaultValue={filters.endDate}
                                    value={filters.endDate}
                                    id="endDate"
                                    label="Data Final da Venda"
                                    type="date"
                                    required={true}
                                    margin="normal"
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    onChange={(ev) =>
                                      handleFilter(ev, "endDate")
                                    }
                                    style={textFieldStyle()}
                                  />
                                  
                                  <FormControl style={selectFieldStyle()}>
                                    <InputLabel htmlFor="integrados">Situação</InputLabel>
                                    <Select  
                                      inputProps={{
                                        id: "integrados",
                                        name: 'integrados',
                                      }}
                                      color="primary"
                                      defaultValue={"Todos"}
                                      value={filters.integrados}
                                      onChange={(ev) => handleFilter(ev, "integrados")}
                                    >
                                      {
                                        integrados.map((tipo: any) => (
                                            <MenuItem key={tipo.tipo} value={tipo.tipo}>{tipo.name}</MenuItem>
                                        ))
                                      }
                                    </Select>
                                  </FormControl>
                                </div>
                                {!processando && (
                                  <IconButton
                                    color="primary"
                                    className="download-button"
                                    onClick={() => requestExport()}
                                  >
                                    <Tooltip title="Exportar">
                                      <GetAppIcon />
                                    </Tooltip>
                                  </IconButton>
                                )}
                                <ExportInProgress
                                  tipos={["ADM_INFORMACOES_SELLOUT"]}
                                  visible={processando}
                                  handleState={(valor) =>
                                    setProcessando(valor)
                                  }
                                />
                              </div>
                              <FormGroup row={true}>
                                <TextField
                                  id="standard-lojas/cnpj-input"
                                  label="SKU/ISBN/Descrição"
                                  className="formTextField"
                                  style={styles.textField}
                                  onChange={(ev) => handleFilter(ev, "term")}
                                  value={filters.term}
                                  type="text"
                                  margin="normal"
                                  fullWidth={true}
                                />
                                <TextField
                                  id="standard-lojas/cnpj-input"
                                  label="Loja/CNPJ"
                                  className="formTextField"
                                  style={styles.textField}
                                  onChange={(ev) => handleFilter(ev, "loja")}
                                  value={filters.loja}
                                  type="text"
                                  margin="normal"
                                  fullWidth={true}
                                />
                              </FormGroup>
                              <CardActions>
                                <Button
                                  onClick={() => handleClearFilter()}
                                  className="filter-dialog-close"
                                >
                                  Limpar
                                </Button>
                                <Button
                                  onClick={() => search(filters)}
                                  className="filter-dialog-close"
                                  color="primary"
                                >
                                  Pesquisar
                                </Button>
                              </CardActions>
                            </CardContent>
                          </form>
                        </CardContent>
                      </Card>
                      <Card>
                        <CardContent>
                          <TableInformacoesSellout
                            loading={loading}
                            rows={listSku}
                            columns={columns}
                            handleChangePage={handleChangePage}
                            sortStatement={filters.sortStatement}
                            changeOrder={(v: any) => handleSort(v)}
                            tableProps={{
                              limit: filters.size,
                              page: filters.page,
                              total: filters.total,
                            }}
                          />
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                </Paper>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default InformacoesSellout;



// WEBPACK FOOTER //
// ./src/component/administration/informacoesSellout/InformacoesSellout.tsx